import "./Button.scss";
import { define } from "../../../Lib/registry";
import type { Component } from "../../../Lib/types";

export type ButtonVariant = "primary" | "secondary";

export interface ButtonClickDetail {
  variant: ButtonVariant;
  el: HTMLElement;
}

export class Button implements Component {
  readonly el: HTMLElement;
  readonly variant: ButtonVariant;

  constructor(el: HTMLElement) {
    this.el = el;
    this.variant = (el.dataset.variant as ButtonVariant) ?? "primary";
    this.init();
  }

  private init(): void {
    this.el.addEventListener("click", this.handleClick);
  }

  private handleClick = (): void => {
    this.el.dispatchEvent(
      new CustomEvent<ButtonClickDetail>("button:click", {
        detail: { variant: this.variant, el: this.el },
        bubbles: true,
      })
    );
  };

  destroy(): void {
    this.el.removeEventListener("click", this.handleClick);
  }
}

define("button", (el) => new Button(el));
